import Vue from 'vue';
import Calculator from '~/components/calculator/base.vue';

Vue.component('Calculator', Calculator);

export default function CalculatorPlugin(ctx) {
  const initialState = ctx.app.$cookies.get('calculator');

  if (!initialState) {
    const amount = ctx.app.store.getters['arithmetic/amount'];

    ctx.app.store.commit('arithmetic/setValue', {
      key: 'amount',
      value: amount.max,
    });
  }
}
